import React from "react";
import { useTranslation } from "react-i18next";

import {
  SelectComponent,
  Button,
  InformationPopUp,
} from "..";
import { Facility } from "../../../state/features/facilityListReducer";
import "./facilityCellPartDropdowns.scss";

interface FacilityCellPartDropdownsProps {
  titleMessage?: string;
  bodyMessage?: any;
  facilityHandler?: (value: any, option: any) => void;
  dropdownValues?: {
    facility?: { text: string };
    cell?: { text: string };
    profile?: { text: string };
  };
  facilityList?: {
    loading: boolean;
    data: Facility[];
  };
  cellHandler?: (value: any, option: any) => void;
  cellList?: {
    loading: boolean;
    data: Array<{ id: number | string; text: string, facility_id?: any }>;
  };
  profileHandler?: (value: any, option: any) => void;
  partNumberList?: {
    loading: boolean;
    data: Array<{ id: string; text: string }>;
  };
  clearDropdownHandler?: () => void;
  isDisabled?: boolean;
}

const FacilityCellPartDropdowns = ({
  titleMessage,
  bodyMessage,
  facilityHandler,
  dropdownValues = {},
  facilityList,
  cellHandler,
  cellList,
  profileHandler,
  partNumberList,
  clearDropdownHandler,
  isDisabled,
}: FacilityCellPartDropdownsProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="fcpDropdownContainer">
        <div className="item">
          <div className="fcpDropdownFacilityLabel">{t('shared.filterDropdowns.facilityLabel')}</div>
          <SelectComponent
            placeholder={t('shared.filterDropdowns.selectFacilityPlaceholder')}
            className="fcpDropdownFacilitySelect"
            onChangeEvent={facilityHandler}
            value={dropdownValues?.facility?.text}
            loading={facilityList?.loading ?? false}
            allowClear
            options={facilityList?.data ?? []}
            disabledOptions={[t('general.loading')]}
            disabled={isDisabled}
          />
        </div>
        <div className="item">
          <div className="fcpDropdownCellLabel">{t('shared.filterDropdowns.cellLabel')}</div>
          <SelectComponent
            placeholder={t('shared.filterDropdowns.selectCellPlaceholder')}
            className="fcpDropdownCellSelect"
            onChangeEvent={cellHandler}
            value={dropdownValues?.cell?.text}
            loading={cellList?.loading ?? false}
            allowClear
            options={cellList?.data ?? []}
            disabledOptions={[t('general.loading'), t('shared.filterDropdowns.selectFacilityPlaceholder')]}
            disabled={isDisabled}
          />
        </div>
        <div className="item">
          <div className="fcpDropdownPartNumberLabel">{t('shared.filterDropdowns.productLabel')}</div>
          <SelectComponent
            placeholder={t('shared.filterDropdowns.selectProductPlaceholder')}
            className="fcpDropdownPartNumberSelect"
            onChangeEvent={profileHandler}
            value={dropdownValues?.profile?.text}
            loading={partNumberList?.loading ?? false}
            allowClear
            options={partNumberList?.data ?? []}
            disabledOptions={[t('general.loading'), t('shared.filterDropdowns.selectCellPlaceholder')]}
            showSearch={true} // Search is for pre-loaded data only-
            disabled={isDisabled}
          />
        </div>
        {!isDisabled ? (
          <div className="clearBtn">
            <Button
              className="fcpDropdownClearBtn fcpDropdownPartNumberSelect"
              onClickEvent={clearDropdownHandler}
              type={""}
            >
              {t('general.clear')}
            </Button>
          </div>
        ) : null}
        <div className="fcpDropdownInfoIcon">
          <InformationPopUp title={titleMessage} content={bodyMessage} />
        </div>
      </div>
    </>
  );
};

export default FacilityCellPartDropdowns;
